/**
 * api地址
 * 如正式环境存在url，则用正式环境url
 */

// 正式环境（能通）
// export const apiBaseUrl = 'http://123.57.84.30'
export const apiBaseUrl = 'https://api.junong360.com'
// export const apiBaseUrl = 'http://jupcapitest.jubaosmart.com'

// 前端配的代理（能通），需配置vue.config.js 文件的 devServer
// export const apiBaseUrl = 'api'

// 为空，调用mock数据，需注释vue.config.js 文件的 devServer
// export const apiBaseUrl = ''

// mock
export const mockApiBaseUrl = 'http://yapi.jeemoo.com/mock/42'

/**
 * 其他配置项
 */

// 高德地图key(需要去高德地图注册申请)
export const amapKey = '65876bff2333e3dfec3a8e98f89c7498'

// 微信appId
export const wxAppId = 'wxf63bc6030b872fc1'

// 微信授权成功 - 回调地址
export const wxRedirectUri = 'http://h5.junong360.com/login'
